import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'motion/react';

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.6);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="fixed bottom-0 left-0 right-0 z-50"
        >
          <div className="w-full bg-primary-950/95 backdrop-blur-md border-t border-white/10">
            <div className="w-full px-6 md:px-10 lg:px-16 py-4">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4 max-w-7xl mx-auto">
                {/* Left — text */}
                <div className="text-center sm:text-left">
                  <p className="text-sm text-white/80 font-medium">
                    Ready to move your business forward?
                  </p>
                  <p className="text-xs text-white/40 hidden sm:block">
                    Get a tailored quote for your trade, procurement, or logistics needs.
                  </p>
                </div>

                {/* Right — CTA */}
                <div className="flex items-center gap-3">
                  <Link
                    to="/contact"
                    className="px-7 py-3 bg-accent-500 text-primary-900 font-semibold text-sm rounded-full hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-accent-500/20"
                  >
                    Get a Quote
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                  <a
                    href="tel:+254715815521"
                    className="hidden md:flex items-center gap-2 px-5 py-3 bg-white/10 text-white text-sm font-medium rounded-full hover:bg-white/20 border border-white/15 transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-phone-line"></i>
                    Call Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}